<template>
  <div>
    <el-form ref="form" :rules="rules" :model="formData">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$l('visit_form_label_manufacturer')||'厂商人员'" prop="scmPerson">
            <el-input v-model="formData.scmPerson" maxlength="20" size="medium" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('visit_form_label_interviewees')||'拜访对象'" prop="visitPerson">
            <el-input v-model="formData.visitPerson" maxlength="20" size="medium" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('visit_form_label_visit_time')||'拜访日期'" prop="visitDate">
            <el-date-picker
              v-model="formData.visitDate"
              type="date"
              value-format="yyyy-MM-dd"
              size="medium"
              style="width:100%;"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('visit_form_label_status')||'状态'" prop="scmVisitStatus">
            <el-radio-group style="width:100%;" size="medium" disabled v-model="formData.scmVisitStatus">
              <el-radio label="Y">有效</el-radio>
              <el-radio label="N">无效</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$l('visit_form_label_purpose')||'拜访目的'" prop="visitTitle">
            <el-input type="textarea" :rows="3" v-model="formData.visitTitle" size="medium" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$l('visit_form_label_visit_detail')||'拜访详情'" prop="visitDescription">
            <el-input type="textarea" :rows="3" v-model="formData.visitDescription" size="medium" placeholder=""></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="text-align: right;margin-top: 100px">
          <el-button size="small" @click="back">{{$l('form_btn_return')||'返回'}}</el-button>
          <el-button size="small" type="primary" @click="save">{{$l('form_btn_save')||'保存'}}</el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>

export default {
  data () {
    return {
      formData: {
        scmPerson: '',
        visitPerson: '',
        visitDate: '',
        scmVisitStatus: '',
        visitDescription: ''
      }, // 数据
      rules: {
          visitDate: [
              { required: true, message: '请选择拜访日期', trigger: 'blur' }
          ]
      }
    }
  },
  methods: {
    init (formData) {
      this.formData = formData
      if (this.formData.type === 'add') {
        this.$refs.form.resetFields()
        this.formData.scmVisitStatus = 'Y'
        this.formData.visitCode = ''
        this.formData.scmCode = formData.scmCode
      }
    },
    save () {
      this.$refs['form'].validate((valid) => {
          if (valid) {
              this.$api.scmInfoVisitSaveApi(this.formData).then(() => {
                  this.$message.success('保存成功')
                  this.$emit('back')
              })
          } else {
              this.$message.warning('请完成表单填写')
          }
      })

    },
    back () {
      this.$emit('back')
    }
  }
}
</script>
